import { APP_DATA } from '../data'

export const getApplicationImageUrl = (path) => {
  if (!path) return null
  try {
    return new URL(path, APP_DATA.apiUrl).toString()
  } catch {
    return null
  }
}
